module.exports = __webpack_public_path__ + "static/media/patients.3469193f.svg";